import { render, staticRenderFns } from "./NewPurchaseOrderDialog.vue?vue&type=template&id=48210ae4&scoped=true"
import script from "./NewPurchaseOrderDialog.vue?vue&type=script&lang=js"
export * from "./NewPurchaseOrderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48210ae4",
  null
  
)

export default component.exports